import axios from '../axios-auth.js'

export function write_to_log(_action, _o1, _o1value, _o2, _o2value, _descr, axios_config) {
       const data = {
           action: _action,
           object1: _o1,
           object1_value: _o1value,
           object2: _o2,
           object2_value: _o2value,
           description: _descr,
       }
       if (axios_config)
        axios.post('/write-to-log2', data, axios_config)
            .then(() => { })
            .catch(() => {
        })      
}
